/**
 * ROC 7
 * Copyright 2016 ROC Commerce
 * 
 * Any modifications required of core files should be handled in supplemental files 
 * or duplicates of said core files. This is to assist in upgrade paths.
 */


define('modules/Cart/CartRailSummary',[
    'jquery',
    'lodash',
    './CartManager',
    'global/all',
    'global/RocAnalytics'
], function ($, _, CartManager, Roc, RocAnalytics) {
    'use strict';

    var cartRailSelector = '#slideCartRail';
    var uiBlockSelector;
    var cartViewModel;
    var isExceeded = false;
    var canModifyPricing = false;
    var states;
    var countries;
    var checkoutUrl;
    var template;
    var punchoutOrder;
    // Customization: If user is processing quoted order, we need to lock all the options that would allow modifying cart
    var isLocked;
    // Customization: There are some additional information displayed when impersonation is active (margin, unit price)
    var isImpersonationActive = false;

    var applyPromoCodeForm = {
        Fields: [
            {
                "Name": 'Promotion Code',
                "Field": '#txtPromoCode',
                "Param": 'promoCode',
                "Type": 'Text'
            }
        ],
        Validate: true
    };

    var estimateShippingForm = {
        Fields: [
            {
                "Name": 'Country',
                "Field": '#estimate-shipping-country',
                "Param": 'country',
                "Type": 'Select'
            },
            {
                "Name": 'City',
                "Field": '#estimate-shipping-city',
                "Param": 'city',
                "Type": 'Text',
                'Optional': true,
                "Validators": [
                    {
                        'Type': 'RequiredIfField',
                        'ConditionalField': '#estimate-shipping-country',
                        'ConditionalFieldAttr': 'data-isPostalCodeRequired',
                        'ConditionalValue': 'false',
                        'ConditionalFieldType': 'Select'
                    }]
            },
            {
                "Name": 'Zip/Postal Code',
                "Field": '#estimate-shipping-zip',
                "Param": 'zip',
                "Type": 'Text',
                'Optional': true,
                "Validators": [
                    {
                        'Type': 'RequiredIfField',
                        'ConditionalField': '#estimate-shipping-country',
                        'ConditionalFieldAttr': 'data-isPostalCodeRequired',
                        'ConditionalValue': 'true',
                        'ConditionalFieldType': 'Select'
                    },
                    {
                        "Type": 'Zip',
                        "ReferencedField": '#estimate-shipping-country',
                        'ReferencedFieldAttr': 'data-isPostalCodeRequired',
                        'ReferencedValue': 'true',
                        'ReferencedFieldType': 'Select'
                    }
                ]
            },
            {
                "Name": 'RecipientId',
                "Field": '#estimate-shipping-recipient-id',
                "Param": 'recipientId',
                "Type": 'Hidden'
            }
        ],
        Validate: true
    };

    var btns = {
        processCheckout: '#btnProceedCheckout',
        estimateShipping: '#estimate-shipping',
        applyPromoCode: '#btnApplyPromoCode',
        removePromoCode: '.removePromoCode'
    };

    function bindViewModel() {
        if (cartViewModel) {
            cartViewModel.isExceeded = isExceeded;
            cartViewModel.isLocked = isLocked; //customization: locking cart when ordering approved quotes
            cartViewModel.isImpersonationActive =
                isImpersonationActive; //customization: show some options only if impersonation is active
            //BEGIN CUSTOMIZATION : to display selected uom label on cartRailSummary 
            _.forEach(cartViewModel.recipients,
                function (recipient) {
                    // Customization: hide shipping options when SFS is available and this is the only one shipping service
                    cartViewModel.hideShippingOptions = recipient.shippingOptions !== undefined &&
                        recipient.shippingOptions !== null &&
                        recipient.shippingOptions.length === 1 &&
                        recipient.shippingOptions[0].isSelected &&
                        recipient.shippingOptions[0].shippingDescription === 'S.Freedman Shipping';

                    var totalCost = 0;
                    var totalPrice = 0;
                    _.forEach(recipient.items,
                        function (item) {
                            var csrCost = item.cost;
                            if (item.unitOfMeasureViewModel && item.unitOfMeasureViewModel.customFields) {
                                item.unitOfMeasureViewModel.quantityInBaseUnit =
                                    item.unitOfMeasureViewModel.customFields["soldByQty"];
                            }
                            if (canModifyPricing) {
                                if (!item.cost && item.cost <= 0) {
                                    item.cost = item.price;
                                    var productCostAtts = item.product.customFields["cost"];
                                    if (productCostAtts && _.some(productCostAtts)) {
                                        item.cost = _.first(productCostAtts).value;
                                    }
                                }

                                if (item.product.productPricing.customFields) {

                                    if (item.product.productPricing.customFields["rebateCost"] > 0) {
                                        item.rebateCost = item.product.productPricing.customFields["rebateCost"];
                                    }

                                    if (item.product.productPricing.unitOfMeasure && item.product.productPricing.unitOfMeasure.isBaseUnit === false && csrCost <= 0) {
                                        var cost = item.cost * item.product.productPricing.unitOfMeasure.quantityInBaseUnit;
                                        item.cost = cost;
                                    }
                                }

                                if (item.rebateCost > 0) {
                                    totalCost = totalCost + (item.rebateCost * item.quantity);
                                }
                                else {
                                    totalCost = totalCost + (item.cost * item.quantity);
                                }
                                totalPrice = totalPrice + (item.price * item.quantity);
                            }

                        })
                    
                    if (canModifyPricing) {
                        var totalMargin = totalPrice - totalCost;
                        var profit = ((totalPrice - totalCost) / totalPrice) * 100;
                        cartViewModel.profit = profit;
                        cartViewModel.totalCost = totalCost;
                        cartViewModel.totalMargin = totalMargin;
                        cartViewModel.canModifyPricing = canModifyPricing;
                    }
                });
            //End Customization

            Roc.OrderHelper.setOrderMargins(cartViewModel); // customization: calculate and set margin
        }
        Roc.UI.template(template, cartViewModel).then(function (renderedTemplate) {
            $(cartRailSelector).html(renderedTemplate);
            if (cartViewModel && cartViewModel.recipients && cartViewModel.recipients.length > 0) {
                var virtualGiftCardsOnly = _.every(cartViewModel.items, { 'isCertificate': true, 'isVirtualItem': true });
                var shippingRecipients = _.filter(cartViewModel.recipients, { 'itemsDeliveryType': 'Shipping' });

                if (!virtualGiftCardsOnly && shippingRecipients.length === 1) {
                    var shippingEstimatorViewModel = {
                        recipient: shippingRecipients[0],
                        isLocked: isLocked,  //customization: locking cart when ordering approved quotes
                        states: states,
                        countries: countries,
                        defaultCountryCode: window.RocConfig.defaultCountryCode,
                        enableInternationalShipping: window.RocConfig.shipping.enableInternationalShipping
                    };

                    Roc.UI.template('#shippingEstimator-Tmp', shippingEstimatorViewModel).then(function (renderedTemplate) {
                        $('#shipping-estimator').html(renderedTemplate);
                        changeCountryEvt();
                    });
                }
            }
        });
    }

    function reload(data) {
        cartViewModel = data;
        Roc.UI.unblock(uiBlockSelector);
        bindViewModel();
    };

    function getCart(forceRecalculate) {
        Roc.UI.block(uiBlockSelector);
        CartManager.getCurrentCart(forceRecalculate);
    }

    function applyPromoCodeCompleted(xhr) {
        var data = xhr.responseJSON || {};

        if (data.status !== 200 && data.message) {
            if (data.message === 'Not found') {
                data.message = 'Sorry, the promotion code you specified is not valid.';
            }

            Roc.UI.displayErrorPopup(data.message);
            Roc.UI.unblock(uiBlockSelector);
            RocAnalytics.recordCheckoutOption(1, data.message);
        } else {
            getCart(true);
            RocAnalytics.recordCheckoutOption(1, 'Promotion Applied');
        }

        Roc.Core.releaseLockedButton(btns.applyPromoCode);
    }

    function applyPromoCodeEvt() {
        $(document).on('click', btns.applyPromoCode, function () {
            var valid = Roc.Validation.validateForm(applyPromoCodeForm);
            if (!valid) {
                return false;
            }
            Roc.Core.lockButton(btns.applyPromoCode);
            Roc.UI.block(uiBlockSelector);
            CartManager.applyPromotionCode(Roc.Forms.getFormValues(applyPromoCodeForm).promoCode);
            return false;
        });
    }

    function removePromoCodeCompleted(xhr) {
        var data = xhr.responseJSON || {};

        if (data.status !== 200 && data.message) {
            Roc.UI.displayErrorPopup(data.message);
            Roc.UI.unblock(uiBlockSelector);
            RocAnalytics.recordCheckoutOption(1, data.message);
        } else {
            getCart(true);
            RocAnalytics.recordCheckoutOption(1, 'Promotion Removed');
        }

        Roc.Core.releaseLockedButton(btns.applyPromoCode);
    }

    function removePromoCodeEvt() {
        $(document).on('click', btns.removePromoCode, function () {
            Roc.UI.block(uiBlockSelector);
            CartManager.removePromotionCode($(this).attr('data-code'));
            return false;
        });
    }

    function shippingMethodSelectedEvt() {
        $(document).on('click', '#shipping-options input[name="shipping"]', function (e) {
            var currentOption = $(e.currentTarget);
            var currentOptionData = currentOption.data();
            var shippingRequest = {
                recipientId: $('#estimate-shipping-recipient-id').val(),
                shippingServiceId: currentOption.val(),
                shippingServiceLabel: currentOptionData.rocParams.name
            };
            Roc.UI.block(uiBlockSelector);
            CartManager.updateShippingDetails(shippingRequest, Roc.Enums.shippingRequestType.SELECT_SERVICE);
        });
    }

    function changeCountryEvt() {
        var changeEventWithNamespace = 'change.cartRailSummary-changeCountryEvt';
        var cityField = $('#estimate-shipping-city');
        var zipField = $('#estimate-shipping-zip');
        var estimateShippingCountrySelector = '#estimate-shipping-country';
        $(document)
            .off(changeEventWithNamespace, estimateShippingCountrySelector)
            .on(changeEventWithNamespace, estimateShippingCountrySelector, function (e) {
                Roc.UI.clearFormErrors(estimateShippingForm);
                zipField.val('');
                cityField.val('');

                var isPostalCodeRequired = ($(this).find('option:selected').attr('data-isPostalCodeRequired') === "true");
                if (isPostalCodeRequired) {
                    zipField.show();
                    cityField.hide();
                } else {
                    zipField.hide();
                    cityField.show();
                }
            });

        //trigger change event to set initial state of country related fields visibility
        $('#estimate-shipping-country').trigger('change');
    }

    function goBackEvt() {
        $(document).on('click', '#shipping-options .go-back', function (e) {
            $('#shipping-options').addClass('hidden');
            $('#estimate-shipping-form').removeClass('hidden');
        });
    }

    function estimateShippingEvt() {
        $(document).on('click', btns.estimateShipping, function () {
            var valid = Roc.Validation.validateForm(estimateShippingForm);

            if (!valid) {
                if (estimateShippingForm.ErrorMsg) {
                    Roc.UI.displayErrorPopup(estimateShippingForm.ErrorMsg);
                };

                return;
            }

            Roc.Core.lockButton(btns.estimateShipping);
            Roc.UI.block(uiBlockSelector);

            var estimateShippingData = Roc.Forms.getFormValues(estimateShippingForm);

            CartManager.updateShippingDetails(estimateShippingData, Roc.Enums.shippingRequestType.UPDATE_ADDRESS);
        });
    }

    function recipientUpdatedEvt(updatedRecipient) {
        var recipientIndex = _.findIndex(cartViewModel.recipients, function (r) { return r.id === updatedRecipient.id });
        if (recipientIndex >= 0) {
            cartViewModel.recipients[recipientIndex] = updatedRecipient;
            if (updatedRecipient.itemsDeliveryType === "Shipping") {
                reload(cartViewModel);
            }
        }
    }

    function shippingUpdatedEvt(data) {
        var xhr = data.xhr;
        var response = xhr.responseJSON;

        if (xhr.status !== 200) {
            Roc.UI.unblock(uiBlockSelector);
            Roc.UI.displayErrorPopup(response.message ? response.message : 'Response error');
            Roc.Core.releaseLockedButton(btns.estimateShipping);
        } else {
            if (response && response.recipient && response.recipient.shippingOptions && response.recipient.shippingOptions === null) {
                Roc.UI.unblock(uiBlockSelector);
                Roc.UI.displayErrorPopup(response.message ? response.message : 'Please ensure your shipping information is correct to estimate shipping.');
                Roc.Core.releaseLockedButton(btns.estimateShipping);
            } else {
                getCart();
            }
        }
    }
    // Customization: custom method for custommer approval
    function updateCustomerBudgetStatus(data) {
        if (data.success) {
            isExceeded = data.isBudgetExceeded;
            var checkoutBtnHtml = "";
            if (data.isBudgetExceeded) {
                checkoutBtnHtml += "Submit for Approval";
            } else {
                checkoutBtnHtml += "Checkout";
            }
            checkoutBtnHtml += '<span class="icon-arrow-bracket-right" aria-hidden="true"></span>';
            $("#proceedToCheckout").html(checkoutBtnHtml);
        } else {
            Roc.UI.displayErrorPopup("Couldn't check customer available budget.");
        }
    }

    function bindEvents() {
        estimateShippingEvt();
        shippingMethodSelectedEvt();
        applyPromoCodeEvt();
        removePromoCodeEvt();
        goBackEvt();
        Roc.EventManager.bind(Roc.Events.checkout.UPDATE_RECIPIENT, recipientUpdatedEvt);
        Roc.EventManager.bind(Roc.Events.cart.UPDATE_SHIPPING_DETAILS, shippingUpdatedEvt);
        Roc.EventManager.bind(Roc.Events.cart.GET_CURRENT_CART, reload);
        Roc.EventManager.bind(Roc.Events.cart.APPLY_PROMO_CODE, applyPromoCodeCompleted);
        Roc.EventManager.bind(Roc.Events.cart.REMOVE_PROMO_CODE, removePromoCodeCompleted);
        // CUSTOMIZATION: if customer budget get exceeded change checkout button to submit for approval
        Roc.EventManager.bind(Roc.Events.budget.IS_EXCEEDED, updateCustomerBudgetStatus);
        Roc.EventManager.bind(Roc.Events.users.LOGIN, function (xhr) {
            var response = xhr.responseJSON || {};
            if (response.success && response.checkoutViewModel) {
                reload(response.checkoutViewModel.order);
            }
        });
        Roc.EventManager.bind(Roc.Events.giftCards.ASSOCIATE_PAYMENT, function (response) {
            if (response.orderCart) {
                reload(response.orderCart);
            }
        });
        Roc.EventManager.bind(Roc.Events.giftCards.REMOVE_PAYMENT, function (response) {
            if (response.orderCart) {
                reload(response.orderCart);
            }
        });
    }

    function init(options) {
        isLocked = options.isLocked;  //customization: locking cart when ordering approved quotes
        isExceeded = options.isExceeded; //customization: customers budget 
        isImpersonationActive = options.isImpersonationActive;
        cartViewModel = options.model.order;
        states = _.sortBy(options.model.states, 'stateName');
        countries = options.model.countries;
        checkoutUrl = options.checkoutUrl;
        punchoutOrder = options.punchoutOrder;
        if (options.canModifyPricing === 'True') {
            canModifyPricing = options.canModifyPricing;
        }
        template = options.template;
        if (options.model.isCheckoutPage) {
            uiBlockSelector = cartRailSelector;
        } else {
            uiBlockSelector = null;
        }
        bindViewModel();
        bindEvents();
    };

    var CartRailSummary = {
        init: init,
        reload: reload
    };

    Roc.Logger.debug('CartRailSummary.js Loaded:', CartRailSummary);

    return CartRailSummary;
});
